export default __webpack_public_path__ + "static/media/chevron-down.02e6f8f6.svg";